// extracted by mini-css-extract-plugin
module.exports = {"section":"section__3S2qE","point-highlight":"point-highlight__sBZI3","point-highlight-item":"point-highlight-item__hgi7q","circle":"circle__38_1a"};